<template>
  <div class="cargo-stackability">
    <CardCargo />
  </div>
</template>

<script>
import CardCargo from './components/CardCargo.vue';

export default {
  name: 'CargoStackability',

  components: {
    CardCargo
  }
};
</script>
